import { Component } from "@angular/core";
import { NavController } from "ionic-angular";
import { Events } from "ionic-angular/util/events";
import { AlertController } from "ionic-angular/components/alert/alert-controller";
import { Whisky } from "../../data/whisky";
import { WhiskyDB } from "../../data/db";
import { NewWhiskyPage } from "../newWhisky/newWhisky";
import { ShowWhiskyPage } from "../showWhisky/showWhisky";
import { ToastController } from "ionic-angular/components/toast/toast-controller";
import { AppRate } from "@ionic-native/app-rate";
import { ModalController } from "ionic-angular/components/modal/modal-controller";

@Component({
  selector: "page-list",
  templateUrl: "list.html"
})
export class ListPage {
  lastFilter: any;
  whisky: Whisky[];
  limit = 20;
  allItems: Whisky[];
  images = {};

  newWhiskyPage: any;
  showWhiskyPage: any;
  loaded: boolean = false;

  sortType: string = "None";

  lastHeader = "___";

  constructor(
    public navCtrl: NavController,
    public events: Events,
    private toastCtrl: ToastController,
    private alertCtrl: AlertController,
    private modalCtrl: ModalController,
    private appRate: AppRate //private network: Network
  ) {
    console.log("Load Database");
    //    if(this.user)
    //      console.log(this.user.isAuthenticated());

    events.subscribe("whisky:updated", () => {
      console.log("got whisky:updated event");
      this.loaded = true;
      this.getItems(this.lastFilter);
      console.log("items " + this.whisky.length);
    });

    /*
    this.events.subscribe("image:loaded", (image: string, name: string, ts: number) => {
      this.images[name] = image;
      console.log("Set thumbnail: " + name);
    }); */

    this.newWhiskyPage = NewWhiskyPage;
    this.showWhiskyPage = ShowWhiskyPage;

    this.appRate.preferences = {
      displayAppName: "WhiskyWall",
      usesUntilPrompt: 5,
      promptAgainForEachNewVersion: false,
      //inAppReview: true,
      storeAppURL: {
        ios: "1317604147",
        android: "market://details?id=whiskywall.oshers.com"
      },
      customLocale: {
        title: "Would you mind rating %@?",
        message:
          "It won’t take more than a minute and helps to promote our app. Thanks for your support!",
        cancelButtonLabel: "No, Thanks",
        laterButtonLabel: "Remind Me Later",
        rateButtonLabel: "Rate It Now",
        yesButtonLabel: "Yes!",
        noButtonLabel: "Not really",
        appRatePromptTitle: "Do you like using %@",
        feedbackPromptTitle: "Mind giving us some feedback?"
      },
      callbacks: {
        handleNegativeFeedback: function() {
          console.log("negative feedback");
          window.open("mailto:developer@oshers.com", "_system");
        },
        onRateDialogShow: function(callback) {
          console.log("onRateDialogShow");
          callback(1); // cause immediate click on 'Rate Now' button
        },
        onButtonClicked: function(buttonIndex) {
          console.log("omButtonClicked-rate dialog");
          console.log("onButtonClicked -> " + buttonIndex);
        }
      }
    };

    this.appRate.promptForRating(false);
  }

  getItems(ev: any) {
    // Sve the filter
    this.lastFilter = ev;
    // set val to the value of the searchbar
    let val = "";
    if (ev != null) {
      val = ev.target.value;
    }
    if (val == null) val = "";
    if (val.length > 0) {
      console.log("filter " + val);
      console.log("filtering " + WhiskyDB.whisky.length + " whiskies");
      this.allItems = WhiskyDB.whisky.filter(item => {
        return (
          item.name.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
          item.distillery.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
          item.region.toLowerCase().indexOf(val.toLowerCase()) > -1
        );
      });
    } else {
      this.allItems = WhiskyDB.whisky;
    }

    console.log("found " + this.allItems.length);
    this.sortChanged();
  }

  sortChanged() {
    this.lastHeader = "___";
    
    console.log("sort change: " + this.sortType);
    this.allItems = this.allItems.sort((a: Whisky, b: Whisky) => {
      switch (this.sortType) {
        case "None":
          return a.name.localeCompare(b.name);
        case "Distillery":
          if (a.distillery === b.distillery)
            return a.name.localeCompare(b.name);
          else return a.distillery.localeCompare(b.distillery);
        case "Region":
          if (a.region !== b.region) {
            return a.region.localeCompare(b.region);
          } else if (a.distillery !== b.distillery) {
            return a.distillery.localeCompare(b.distillery);
          } else {
            return a.name.localeCompare(b.name);
          }
        case "Shelf":
          if (a.shelves[0] === null) a.shelves[0] = "";
          if (b.shelves[0] === null) b.shelves[0] = "";
          if (a.shelves[0] !== b.shelves[0]) {
            return a.shelves[0].localeCompare(b.shelves[0]);
          } else if (a.distillery !== b.distillery) {
            return a.distillery.localeCompare(b.distillery);
          } else {
            return a.name.localeCompare(b.name);
          }
        case "Bottler":
          if (a.bottler !== b.bottler) {
            return a.bottler.localeCompare(b.bottler);
          } else if (a.distillery !== b.distillery) {
            return a.distillery.localeCompare(b.distillery);
          } else {
            return a.name.localeCompare(b.name);
          }
        case "Rating":
          if (a.rating !== b.rating) {
            return a.rating.localeCompare(b.rating);
          } else if (a.distillery !== b.distillery) {
            return a.distillery.localeCompare(b.distillery);
          } else {
            return a.name.localeCompare(b.name);
          }
        default:
          return -1;
      }
    });
    this.limit = 20;
    this.whisky = this.allItems.slice(
      0,
      Math.min(this.limit, this.allItems.length)
    );

    this.findHeaders();
    
  }

  doInfinite(event: any) {
    //console.log("doInfinite");
    // Get next chunk from all filtered & sorted items
    let prior = this.limit;
    this.limit = this.limit + 20;
    //console.log("get more items: " + this.limit);
    this.limit = Math.min(this.limit, this.allItems.length);
    let moreItems = this.allItems.slice(prior, this.limit);

    moreItems.forEach(i => {
      this.whisky.push(i);
/*      if(this.images[i.name] == null) {
        WhiskyDB.db.loadImage(i);    
      } */
    });

    this.findHeaders();
    event.complete();
  }

  getSubHead(item: Whisky) {
    return item.distillery + " - " + item.region + " - " + item.rating;
  }
  getSubSubHead(item: Whisky) {
    if (item.bottler.length > 0) return item.bottler + " - " + item.shelves[0];
    else return item.shelves[0];
  }

  addToCart(e: any, slider: any) {
    slider.close();
    console.log("addToCart " + e);
    WhiskyDB.basket.push(e);
    WhiskyDB.db.saveBasket();
    this.events.publish("basket:updated");

    let toast = this.toastCtrl.create({
      message: e.name + " was added to the shopping list.",
      duration: 3000
    });
    toast.present();
  }

  remove(toRemove: any, slider: any) {
    slider.close();
    let alert = this.alertCtrl.create({
      title: "Remove from collection?",
      subTitle: toRemove.name,
      cssClass: "removeAlert",
      buttons: [
        {
          text: "Cancel",
          role: "Cancel",
          handler: () => {
            console.log("Cancel remove");
          }
        },
        {
          text: "Remove",
          cssClass: "remove-button",
          handler: () => {
            // Remove selected items
            console.log("Remove: " + toRemove.name);
            // Remove is via a filter
            WhiskyDB.whisky = WhiskyDB.whisky.filter(item => {
              return item.name !== toRemove.name;
            });

            // Save them
            WhiskyDB.db.saveWhisky();
            this.events.publish("whisky:updated");
          }
        }
      ]
    });
    alert.present();
  }

  select(e: any) {
    console.log("onClick " + e);
    let modal = this.modalCtrl.create(this.showWhiskyPage, { Whisky: e });
    modal.present();
  }

  newWhisky() {
    let modal = this.modalCtrl.create(this.newWhiskyPage, { whisky: null });
    modal.present();
    // this.navCtrl.push(NewWhiskyPage, { whisky: null });
  }

  editItem(e: any, slider: any) {
    slider.close();
    console.log("edit " + e);
    let modal = this.modalCtrl.create(this.newWhiskyPage, { whisky: e });
    modal.present();

    //this.navCtrl.push(NewWhiskyPage, { whisky: e });
  }

  findHeaders()
  {
    this.lastHeader = "____";
    this.lastVal = false;

    // Clear previous header
    this.whisky.forEach( item => 
    {
      item.isHeader= false;
    });
    
    this.whisky.forEach( item => {
      item.isHeader= this.isHeader(item, true);
      //if(item.isHeader)
      //  console.log("Is header: " + item.name);
    }); 
    //console.log("Done getting headers");
  }

  lastVal = false;
  isHeader(item: Whisky, calc: boolean = false) {
    if(calc == false)
      return item.isHeader;
    
    if (item.shelves[0] == null) item.shelves[0] = "";

    //console.log("isHeader last=" + this.lastHeader);
    var rval = false;
    switch (this.sortType) {
      default:
        rval = false;
        break;
      case "Region":
        rval = this.lastHeader !== item.region;
        break;
      case "Rating":
        rval = this.lastHeader !== item.rating;
        break;
      case "Bottler":
        if (item.bottler == null) item.bottler = "";
        rval = this.lastHeader !== item.bottler;
        break;
      case "Distillery":
        rval = this.lastHeader !== item.distillery;
        break;
      case "Shelf":
        rval = this.lastHeader !== item.shelves[0];
        break;
    }
    this.lastVal = rval;
    if(rval)
    {
      if(this.sortType === "Bottler")
        this.lastHeader = item.bottler;
      else
        this.lastHeader = this.getHeader(item);
      
    }

    return rval;
  }

  getHeader(item: Whisky) {
    switch (this.sortType) {
      default:
        this.lastHeader = "";
        break;
      case "Region":
        this.lastHeader = item.region;
        break;
      case "Rating":
        this.lastHeader = item.rating;
        break;
      case "Bottler":
        this.lastHeader = item.bottler;
        break;
      case "Distillery":
        this.lastHeader = item.distillery;
        break;
      case "Shelf":
        this.lastHeader = item.shelves[0];
    }
    //console.log("lastHeader = " + this.lastHeader);
    if (this.sortType === "Bottler" && this.lastHeader === "")
      return "Distillery Bottling";
    return this.lastHeader;
  }

  reminderToSetRating() {}
}



// WEBPACK FOOTER //
// ./src/pages/list/list.ts